var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { remove } from '@syncfusion/ej2-base';
import { ContextMenu as Menu } from '@syncfusion/ej2-navigations';
import { contextMenuClick, contextMenuOpen, contextMenuBeforeItemRender } from '../enum/enum';
import { createHtmlElement } from '../../diagram/utility/dom-util';
/**
 * @private
 */
export const menuClass = {
    content: '.e-diagramcontent',
    copy: 'e-copy',
    paste: 'e-paste',
    undo: 'e-undo',
    redo: 'e-redo',
    cut: 'e-cut',
    selectAll: 'e-selectall',
    grouping: 'e-grouping',
    group: 'e-group',
    unGroup: 'e-ungroup',
    bringToFront: 'e-bringfront',
    sendToBack: 'e-sendback',
    moveForward: 'e-bringforward',
    sendBackward: 'e-sendbackward',
    order: 'e-order'
};
/**
 * 'ContextMenu module used to handle context menu actions.'
 *
 * @private
 */
export class DiagramContextMenu {
    constructor(parent, service) {
        this.defaultItems = {};
        /**
         * @private
         */
        this.disableItems = [];
        /**
         * @private
         */
        this.hiddenItems = [];
        this.localeText = this.setLocaleKey();
        this.parent = parent;
        this.serviceLocator = service;
        this.addEventListener();
    }
    /**
     * addEventListener method \
     *
     * @returns { void } addEventListener method .\
     *
     * @private
     */
    addEventListener() {
        if (this.parent.isDestroyed) {
            return;
        }
        this.parent.on('initial-load', this.render, this);
    }
    /**
     * removeEventListener method \
     *
     * @returns { void } removeEventListener method .\
     *
     * @private
     */
    removeEventListener() {
        if (this.parent.isDestroyed) {
            return;
        }
        this.parent.off('initial-load', this.render);
    }
    render() {
        this.l10n = this.serviceLocator.getService('localization');
        this.element = createHtmlElement('ul', { id: this.parent.element.id + '_contextMenu' });
        this.parent.element.appendChild(this.element);
        const target = '#' + this.parent.element.id;
        this.contextMenu = new Menu({
            items: this.getMenuItems(),
            enableRtl: this.parent.enableRtl,
            enablePersistence: this.parent.enablePersistence,
            locale: this.parent.locale,
            target: target,
            select: this.contextMenuItemClick.bind(this),
            beforeOpen: this.contextMenuBeforeOpen.bind(this),
            onOpen: this.contextMenuOpen.bind(this),
            beforeItemRender: this.BeforeItemRender.bind(this),
            onClose: this.contextMenuOnClose.bind(this),
            cssClass: 'e-diagram-menu',
            animationSettings: { effect: 'None' }
        });
        this.contextMenu.appendTo(this.element);
    }
    getMenuItems() {
        const menuItems = [];
        const orderItems = [];
        const groupItems = [];
        if (!this.parent.contextMenuSettings.showCustomMenuOnly) {
            for (const item of this.getDefaultItems()) {
                if (item.toLocaleLowerCase().indexOf('group') !== -1) {
                    if (item.toLocaleLowerCase() !== 'grouping') {
                        groupItems.push(this.buildDefaultItems(item));
                    }
                }
                else if (item.toLocaleLowerCase().indexOf('order') !== -1) {
                    if (item.toLocaleLowerCase() !== 'order') {
                        orderItems.push(this.buildDefaultItems(item));
                    }
                }
                else {
                    menuItems.push(this.buildDefaultItems(item));
                }
            }
            const groupMenus = this.buildDefaultItems('grouping');
            groupMenus.items = groupItems;
            menuItems.push(groupMenus);
            const orderMenus = this.buildDefaultItems('order');
            orderMenus.items = orderItems;
            menuItems.push(orderMenus);
        }
        if (this.parent.contextMenuSettings.items) {
            for (const customItem of this.parent.contextMenuSettings.items) {
                menuItems.push(customItem);
            }
        }
        return menuItems;
    }
    contextMenuOpen() {
        this.isOpen = true;
    }
    BeforeItemRender(args) {
        this.parent.trigger(contextMenuBeforeItemRender, args);
    }
    contextMenuItemClick(args) {
        document.getElementById(this.parent.element.id + 'content').focus();
        this.parent.trigger(contextMenuClick, args);
        const item = this.getKeyFromId(args.item.id);
        if (!args.cancel) {
            switch (item) {
                case 'cut':
                    this.parent.cut();
                    break;
                case 'copy':
                    this.parent.copy();
                    break;
                case 'undo':
                    this.parent.undo();
                    break;
                case 'redo':
                    this.parent.redo();
                    break;
                case 'paste':
                    this.parent.paste();
                    break;
                case 'selectAll':
                    this.parent.selectAll();
                    break;
                case 'group':
                    this.parent.group();
                    break;
                case 'unGroup':
                    this.parent.unGroup();
                    break;
                case 'bringToFrontOrder':
                    this.parent.bringToFront();
                    break;
                case 'moveForwardOrder':
                    this.parent.moveForward();
                    break;
                case 'sendToBackOrder':
                    this.parent.sendToBack();
                    break;
                case 'sendBackwardOrder':
                    this.parent.sendBackward();
                    break;
            }
        }
    }
    contextMenuOnClose(args) {
        const parent = 'parentObj';
        if (args.items.length > 0 && args.items[0][`${parent}`] instanceof Menu) {
            this.updateItemStatus();
        }
    }
    getLocaleText(item) {
        return this.l10n.getConstant(this.localeText[`${item}`]);
    }
    updateItemStatus() {
        this.contextMenu.showItems(this.hiddenItems, true);
        this.contextMenu.enableItems(this.disableItems, false, true);
        this.hiddenItems = [];
        this.disableItems = [];
        this.isOpen = false;
    }
    /**
     * ensureItems method \
     *
     * @returns { void } ensureItems method .\
     * @param {MenuItemModel} item - provide the item value.
     * @param {Event} event - provide the event value.
     *
     * @private
     */
    ensureItems(item, event) {
        const key = this.getKeyFromId(item.id);
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const dItem = this.defaultItems[`${key}`];
        if (this.getDefaultItems().indexOf(key) !== -1) {
            if (item.target && (event || this.parent.checkMenu) &&
                !this.ensureTarget(item)) {
                this.hiddenItems.push(item.id);
            }
        }
    }
    /**
     * refreshItems method \
     *
     * @returns { void } refreshItems method .\
     *
     * @private
     */
    refreshItems() {
        this.updateItems();
        this.contextMenu.refresh();
    }
    updateItems() {
        let canInsert = true;
        for (let i = 0; i < this.parent.contextMenuSettings.items.length; i++) {
            const items = this.parent.contextMenuSettings.items[parseInt(i.toString(), 10)];
            for (let j = 0; j < this.contextMenu.items.length; j++) {
                if (this.contextMenu.items[parseInt(j.toString(), 10)].text
                    === this.parent.contextMenuSettings.items[parseInt(i.toString(), 10)].text) {
                    canInsert = false;
                }
            }
            if (canInsert) {
                this.contextMenu.insertAfter([items], this.contextMenu.items[this.contextMenu.items.length - 1].text);
            }
        }
    }
    contextMenuBeforeOpen(args) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.parent.checkMenu &&
                (window.navigator.userAgent.indexOf('Linux') !== -1 || window.navigator.userAgent.indexOf('X11') !== -1)) {
                this.parent.checkMenu = args.cancel = true;
            }
            if (this.parent.checkMenu) {
                this.hiddenItems = [];
            }
            const diagramArgs = args;
            diagramArgs.hiddenItems = [];
            for (const item of args.items) {
                this.ensureItems(item, args.event);
                if (item.items.length) {
                    for (const newItem of item.items) {
                        this.ensureItems(newItem, args.event);
                    }
                }
            }
            this.eventArgs = args.event;
            //Removed isBlazor code
            this.parent.trigger(contextMenuOpen, diagramArgs);
            let hidden = true;
            this.hiddenItems = this.hiddenItems.concat(diagramArgs.hiddenItems);
            this.contextMenu.enableItems(this.disableItems, false, true);
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const contextItems = this;
            for (let i = 0; i < args.items.length; i++) {
                const item = args.items[parseInt(i.toString(), 10)];
                if (contextItems.hiddenItems.indexOf(item.id) > -1) {
                    contextItems.contextMenu.hideItems([item.id], true);
                }
            }
            for (let i = 0; i < contextItems.contextMenu.items.length; i++) {
                const item = contextItems.contextMenu.items[parseInt(i.toString(), 10)];
                if (contextItems.hiddenItems.indexOf(item.id) === -1) {
                    hidden = false;
                    contextItems.contextMenu.showItems([item.id], true);
                }
            }
            if (hidden) {
                diagramArgs.cancel = hidden;
                this.hiddenItems = [];
            }
            /* tslint:disable */
            if (this.parent.selectedItems.nodes.length && this.parent.selectedItems.nodes[0].isPhase
                && !this.parent.contextMenuSettings.showCustomMenuOnly) {
                args.cancel = true;
            }
            /* tslint:enable */
        });
    }
    ensureTarget(item) {
        const selectedLength = this.parent.selectedItems.nodes.length +
            this.parent.selectedItems.connectors.length;
        const itemText = this.getKeyFromId(item.id);
        let target = false;
        switch (itemText) {
            case 'undo':
                target = this.parent.historyManager && this.parent.historyManager.canUndo ? true : false;
                break;
            case 'redo':
                target = this.parent.historyManager && this.parent.historyManager.canRedo ? true : false;
                break;
            case 'paste':
                target = this.parent.commandHandler.clipboardData.clipObject ? true : false;
                break;
            case 'selectAll':
                target = this.parent.nodes.length + this.parent.connectors.length ? true : false;
                break;
            case 'grouping':
                target = ((selectedLength > 1) || (this.parent.selectedItems.nodes[0] && this.parent.selectedItems.nodes[0].children
                    && this.parent.selectedItems.nodes[0].children.length > 1)) ? true : false;
                break;
            case 'group':
                target = selectedLength > 1;
                break;
            case 'unGroup':
                target = (((this.parent.selectedItems.nodes.length === 1 && this.parent.selectedItems.connectors.length === 0)
                    && this.parent.selectedItems.nodes[0] && this.parent.selectedItems.nodes[0].children
                    && this.parent.selectedItems.nodes[0].children.length > 1)) ? true : false;
                break;
            case 'cut':
            case 'copy':
            case 'order':
            case 'bringToFrontOrder':
            case 'moveForwardOrder':
            case 'sendToBackOrder':
            case 'sendBackwardOrder':
                target = selectedLength ? true : false;
                break;
        }
        return target;
    }
    /**
     *To destroy the context menu
     *
     * @returns {void} To destroy the context menu
     */
    destroy() {
        this.contextMenu.destroy();
        remove(this.element);
        this.removeEventListener();
    }
    getModuleName() {
        return 'contextMenu';
    }
    generateID(item) {
        return this.parent.element.id + '_contextMenu_' + item;
    }
    getKeyFromId(id) {
        return id.replace(this.parent.element.id + '_contextMenu_', '');
    }
    buildDefaultItems(item) {
        let menuItem;
        switch (item) {
            case 'copy':
                menuItem = { target: menuClass.content, iconCss: menuClass.copy };
                break;
            case 'cut':
                menuItem = { target: menuClass.content, iconCss: menuClass.cut };
                break;
            case 'paste':
                menuItem = { target: menuClass.content, iconCss: menuClass.paste };
                break;
            case 'undo':
                menuItem = { target: menuClass.content, iconCss: menuClass.undo };
                break;
            case 'redo':
                menuItem = { target: menuClass.content, iconCss: menuClass.redo };
                break;
            case 'grouping':
                menuItem = { target: menuClass.content };
                break;
            case 'group':
                menuItem = { target: menuClass.content, iconCss: menuClass.group };
                break;
            case 'unGroup':
                menuItem = { target: menuClass.content, iconCss: menuClass.unGroup };
                break;
            case 'order':
                menuItem = { target: menuClass.content, iconCss: menuClass.order };
                break;
            case 'bringToFrontOrder':
                menuItem = { target: menuClass.content, iconCss: menuClass.bringToFront };
                break;
            case 'moveForwardOrder':
                menuItem = { target: menuClass.content, iconCss: menuClass.moveForward };
                break;
            case 'sendToBackOrder':
                menuItem = { target: menuClass.content, iconCss: menuClass.sendToBack };
                break;
            case 'sendBackwardOrder':
                menuItem = { target: menuClass.content, iconCss: menuClass.sendBackward };
                break;
            case 'selectAll':
                menuItem = { target: menuClass.content };
                break;
        }
        this.defaultItems[`${item}`] = {
            text: this.getLocaleText(item), id: this.generateID(item),
            target: menuItem.target, iconCss: menuItem.iconCss ? 'e-icons ' + menuItem.iconCss : ''
        };
        return this.defaultItems[`${item}`];
    }
    getDefaultItems() {
        return [
            'copy',
            'cut', 'paste', 'undo', 'redo', 'selectAll', 'grouping', 'group', 'unGroup', 'order',
            'bringToFrontOrder', 'moveForwardOrder', 'sendToBackOrder', 'sendBackwardOrder'
        ];
    }
    setLocaleKey() {
        return {
            'copy': 'Copy',
            'cut': 'Cut',
            'paste': 'Paste',
            'undo': 'Undo',
            'redo': 'Redo',
            'selectAll': 'SelectAll',
            'grouping': 'Grouping',
            'group': 'Group',
            'unGroup': 'UnGroup',
            'order': 'Order',
            'bringToFrontOrder': 'BringToFront',
            'moveForwardOrder': 'MoveForward',
            'sendToBackOrder': 'SendToBack',
            'sendBackwardOrder': 'SendBackward'
        };
    }
}
